module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA/ElEQVRYR+3Wuw3CMBAGYJ8V6IAMw7vPCuyRJRBpCC19FqAjYQVWQFRQIAoahADrjI3kjsKJLZ2QnAFyn3/7zgZG/AFxfRYAIYFaCWTLV59xmLdlNEtTuPk4wNYAXRw47BAx5sD3LRYlPhD2gNW7koiJWbUvhDUgz2X8BFExxIFPhDVAF12sZQ/uopIMh74QtQAGwR6iVEmMfCBqA3TRopDd00WUKomxK6IRwCDOV7FVXTFxQTQG6KLZRnbgKEoXhBPAINhBbNV2TJsk8d8A0i3QnUB2CEnbUE9DskFEOorJL6OM+jomf5B8px7lk8zH++/XP5xHsSssAEICH+fJxCGWlcdkAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_more.png
// module id = nypa
// module chunks = 1